"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTheme = exports.THEMES = void 0;
var _Mobile = require("../themes/Mobile/Mobile");
var _Internal = require("../themes/Internal/Internal");
var THEMES = {
  MOBILE: "MOBILE",
  INTERNAL: "INTERNAL"
};
exports.THEMES = THEMES;
var getTheme = function getTheme(theme) {
  switch (theme) {
    case THEMES.MOBILE:
      return (0, _Mobile.defaultTheme)();
    case THEMES.INTERNAL:
      return (0, _Internal.defaultTheme)();
    default:
      return (0, _Mobile.defaultTheme)();
  }
};
exports.getTheme = getTheme;